import { defineStore } from 'pinia';

export const userPlanetDataStorage = defineStore('userPlanetDataStorage', {
    state: () => ({
        planets: []
    }),
    actions: {
        upsertPlanet(planet) {
            const planetIndex = this.planets.findIndex(p => p.planetId === planet.planetId);
            
            if (planetIndex !== -1) {
                this.planets[planetIndex] = { ...this.planets[planetIndex], ...planet };
            } else {
                this.addPlanet(planet);
            }
        },
        addPlanet(planet) {
            this.planets.push(planet);
        },
        updatePlanet(id, updates) {
            const planetIndex = this.planets.findIndex(p => p.planetId === id);
            if (planetIndex !== -1) {
                this.planets[planetIndex] = { ...this.planets[planetIndex], ...updates };
            }
        },
        updatePlanetResources(id, updates) {
            const planetIndex = this.planets.findIndex(p => p.planetId === id);
            if (planetIndex !== -1) {
                const planet = this.planets[planetIndex];
                
                for (const key in updates) {
                    planet[key] += updates[key];
                }
            }
        },
        removePlanet(id) {
            this.planets = this.planets.filter(planet => planet.planetId !== id);
        }
    },
    getters: {
        getPlanetById: (state) => (id) => {
            return state.planets.find(planet => planet.planetId === id);
        }
    }
});